import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { SidenavService } from './layout/sidenav/sidenav.service';
import { Platform } from '@angular/cdk/platform';
import { SplashScreenService } from '../@fury/services/splash-screen.service';
import { AuthenticationService } from './services/base/authentication.service';
import { User } from './interfaces/routering/user';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppUpdateDialogComponent } from '../@fury/shared/dialog/app-update-dialog/app-update-dialog.component';
import { SnackbarService } from './services/base/snackbar.service';
import { interval, Observable } from 'rxjs';
import { LayoutService } from './layout/layout.service';
import { SidenavItem } from './layout/sidenav/sidenav-item/sidenav-item.interface';
import { environment } from '../environments/environment';

@Component({
  selector: 'fury-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

  private swUpdatePending: boolean = false;

  private sidenavTopItems: SidenavItem[] = [
    {
      uniqueId: 'all-reports',
      name: 'Alle meldingen',
      routeOrFunction: '/alle-meldingen',
      icon: 'assignment',
      position: 0,
      badgeItem: 'reports_overview',
      permissions: [
        'reports.view.all',
      ],
    },
    {
      uniqueId: 'my-reports',
      name: 'Mijn meldingen',
      icon: 'assignment_ind',
      position: 10,
      alwaysOpened: true,
      permissions: [
        'reports.unassigned.assign',
        'reports.handle.bulk',
        'reports.copy',
        'reports.create',
        'reports.delete',
        'reports.closed.edit',
        'reports.forward',
        'reports.print',
        'reports.closed.reopen',
        'reports.handle',
        'reports.deleted.read',
        'reports.unassigned.view',
        'reports.update',
        'reports.view',
      ],
      subItems: [
        {
          uniqueId: 'open-reports',
          name: 'Openstaand',
          routeOrFunction: '/meldingen',
          icon: 'assignment',
          position: 10,
          badgeItem: 'reports_open',
          permissions: [
            'reports.unassigned.assign',
            'reports.handle.bulk',
            'reports.copy',
            'reports.create',
            'reports.delete',
            'reports.closed.edit',
            'reports.forward',
            'reports.print',
            'reports.closed.reopen',
            'reports.handle',
            'reports.deleted.read',
            'reports.unassigned.view',
            'reports.update',
            'reports.view',
          ],
        },
        {
          uniqueId: 'control-reports',
          name: 'Controle',
          routeOrFunction: '/meldingen/controle',
          icon: 'assignment',
          position: 11,
          badgeItem: 'reports_review',
          permissions: [
            'reports.review',
          ],
        },
        {
          uniqueId: 'closed-reports',
          name: 'Gesloten',
          routeOrFunction: '/meldingen/gesloten',
          icon: 'assignment_turned_in',
          position: 15,
          badgeItem: 'reports_closed',
          permissions: [
            'reports.unassigned.assign',
            'reports.handle.bulk',
            'reports.copy',
            'reports.create',
            'reports.delete',
            'reports.closed.edit',
            'reports.forward',
            'reports.print',
            'reports.closed.reopen',
            'reports.handle',
            'reports.deleted.read',
            'reports.unassigned.view',
            'reports.update',
            'reports.view',
          ],
        },
      ]
    },
    {
      uniqueId: 'new-reports',
      name: 'Nieuwe melding',
      routeOrFunction: '/meldingen/nieuw',
      icon: 'add_user',
      position: 15,
      alwaysOpened: false,
      permissions: [
        'reports.create'
      ],
    },
    {
      uniqueId: 'map-overview',
      name: 'Kaart weergave',
      routeOrFunction: '/kaart-weergave',
      icon: 'map',
      position: 96,
      alwaysOpened: false,
      permissions: [
        'map.view',
      ],
    },
    {
      uniqueId: 'reports',
      name: 'Rapportages',
      routeOrFunction: '/statistics',
      icon: 'insert_chart',
      position: 97,
      alwaysOpened: false,
      permissions: [
        'statistics.read'
      ],
    },
    {
      uniqueId: 'waste-orders',
      name: 'Afroeporders',
      icon: 'assignment',
      position: 98,
      alwaysOpened: false,
      permissions: [
        'waste-orders.manage',
      ],
      subItems: [
        {
          uniqueId: 'open-waste-orders',
          name: 'Openstaand',
          routeOrFunction: '/afroeporders',
          position: 10,
          badgeItem: 'waste_orders_open',
          permissions: [
            'waste-orders.manage',
          ],
        },
        {
          uniqueId: 'closed-waste-orders',
          name: 'Opgehaald',
          routeOrFunction: '/afroeporders/opgehaald',
          position: 20,
          badgeItem: 'waste_orders_closed',
          permissions: [
            'waste-orders.manage',
          ],
        },
        {
          uniqueId: 'all-waste-orders',
          name: 'Alle',
          routeOrFunction: '/afroeporders/alle',
          position: 30,
          badgeItem: 'waste_orders_all',
          permissions: [
            'waste-orders.manage',
          ],
        },
      ],
    },
    {
      uniqueId: 'new-waste-order',
      name: 'Nieuwe afroeporder',
      routeOrFunction: '/afroeporders/nieuw',
      icon: 'add_user',
      position: 99,
      alwaysOpened: false,
      permissions: [
        'waste-orders.manage'
      ],
    },
    {
      uniqueId: 'control',
      name: 'BEHEER',
      position: 100,
      type: 'subheading',
      permissions: [
        'routering.organisations.manage',
        'routering.departments.manage',
        'routering.roles.manage',
        'routering.users.manage',
        'routering.categories.manage',
        'routering.organisations.manage',
        'routering.departments.manage',
        'routering.roles.manage',
        'routering.users.manage',
        'routering.categories.manage',
        'configuration.public-notifications.manage',
        'configuration.email-templates.manage',
        'configuration.standard-reactions.manage',
        'configuration.address-book.manage',
        'configuration.knowledge-base.manage',
        'configuration.faq.manage',
        'configuration.changelogs.manage',
        'configuration.report-statuses.manage',
        'configuration.report-sources.manage',
        'configuration.report-priorities.manage',
        'configuration.report-history.manage',
        'archive.manage',
        'waste-calendar.manage',
        'configuration.waste-order-statuses-and-types.manage',
        'configuration.reporters.manage',
        'configuration.postalcode-groups.manage',
      ],
    },
    {
      uniqueId: 'routering',
      name: 'Routering',
      icon: 'call_split',
      position: 100,
      alwaysOpened: false,
      permissions: [
        'routering.organisations.manage',
        'routering.departments.manage',
        'routering.roles.manage',
        'routering.users.manage',
        'routering.categories.manage',
      ],
      subItems: [
        {
          uniqueId: 'organisations',
          name: 'Organisaties',
          routeOrFunction: '/routering/organisaties',
          position: 10,
          permissions: [
            'routering.organisations.manage'
          ],
        },
        {
          uniqueId: 'departments',
          name: 'Afdelingen',
          routeOrFunction: '/routering/afdelingen',
          position: 15,
          permissions: [
            'routering.departments.manage',
          ],
        },
        {
          uniqueId: 'user-roles',
          name: 'Gebruikertypes',
          routeOrFunction: '/routering/gebruikertypes',
          position: 20,
          permissions: [
            'routering.roles.manage',
          ],
        },
        {
          uniqueId: 'users',
          name: 'Gebruikers',
          routeOrFunction: '/routering/gebruikers',
          position: 25,
          permissions: [
            'routering.users.manage',
          ],
        },
        {
          uniqueId: 'categories',
          name: 'Hoofdcategorie',
          routeOrFunction: '/routering/categorieen',
          position: 30,
          permissions: [
            'routering.categories.manage'
          ],
        },
      ]
    },
    {
      uniqueId: 'public-notifications',
      name: 'Notificaties',
      icon: 'add_alert',
      position: 140,
      alwaysOpened: false,
      permissions: [
        'configuration.public-notifications.manage',
      ],
      subItems: [
        {
          uniqueId: 'website-notifications',
          name: 'Aankondigingen',
          position: 0,
          routeOrFunction: '/notificaties/aankondigingen',
        },
        {
          uniqueId: 'app-notifications',
          name: 'App aankondigingen',
          position: 10,
          routeOrFunction: '/notificaties/app-aankondigingen',
        },
        {
          uniqueId: 'notification-types',
          name: 'Publieke notificaties types',
          routeOrFunction: '/notificaties/aankondigingen/types',
          position: 20,
          permissions: [
            'configuration.public-notifications.manage'
          ],
        },
      ],
    },
    {
      uniqueId: 'configuration',
      name: 'Instellingen',
      icon: 'settings',
      position: 150,
      alwaysOpened: false,
      permissions: [
        'configuration.cities.manage',
        'configuration.email-templates.manage',
        'configuration.standard-reactions.manage',
        'configuration.address-book.manage',
        'configuration.knowledge-base.manage',
        'configuration.faq.manage',
        'configuration.changelogs.manage',
        'configuration.report-statuses.manage',
        'configuration.report-sources.manage',
        'configuration.report-priorities.manage',
        'configuration.report-history.manage',
        'configuration.blacklist.manage',
        'configuration.waste-order-statuses-and-types.manage',
        'configuration.postalcode-groups.manage',
        'configuration.contractor-agreement.manage',
      ],
      subItems: [
        {
          uniqueId: 'cities',
          name: 'Steden',
          routeOrFunction: '/instellingen/steden',
          position: 0,
          permissions: [
            'configuration.cities.manage'
          ],
        },
        {
          uniqueId: 'email-templates',
          name: 'E-mail templates',
          routeOrFunction: '/instellingen/email-templates',
          position: 10,
          permissions: [
            'configuration.email-templates.manage'
          ],
        },
        {
          uniqueId: 'standard-reactions',
          name: 'Standaard reacties',
          routeOrFunction: '/instellingen/standaard-reacties',
          position: 15,
          permissions: [
            'configuration.standard-reactions.manage'
          ],
        },
        {
          uniqueId: 'address-book',
          name: 'Adressenboek',
          routeOrFunction: '/instellingen/adressenboek',
          position: 20,
          permissions: [
            'configuration.address-book.manage'
          ],
        },
        {
          uniqueId: 'knowledge-base-section',
          name: 'Handleiding',
          position: 25,
          alwaysOpened: false,
          permissions: [
            'configuration.knowledge-base.manage',
            'configuration.faq.manage',
            'configuration.changelogs.manage',
          ],
          subItems: [
            {
              uniqueId: 'knowledge-base',
              name: 'Handleiding',
              routeOrFunction: '/instellingen/handleiding',
              position: 10,
              permissions: [
                'configuration.knowledge-base.manage',
              ]
            },
            {
              uniqueId: 'faq',
              name: 'FAQ',
              routeOrFunction: '/instellingen/handleiding/faq',
              position: 15,
              permissions: [
                'configuration.faq.manage',
              ]
            },
            {
              uniqueId: 'contact-details',
              name: 'Contact gegevens',
              routeOrFunction: '/instellingen/handleiding/contact-gegevens',
              position: 20,
              permissions: []
            },
            {
              uniqueId: 'application-updates',
              name: 'Update applicatie',
              position: 25,
              routeOrFunction: '/instellingen/handleiding/update-applicatie',
              permissions: [
                'configuration.changelogs.manage',
              ],
            },
          ],
        },
        {
          uniqueId: 'report-configuration',
          name: 'Invoer',
          alwaysOpened: false,
          position: 30,
          permissions: [
            'configuration.report-statuses.manage',
            'configuration.report-sources.manage',
            'configuration.report-priorities.manage',
            'configuration.report-history.manage',
          ],
          subItems: [
            {
              uniqueId: 'report-statuses',
              name: 'Statussen',
              routeOrFunction: '/instellingen/invoer/statussen',
              position: 15,
              permissions: [
                'configuration.report-statuses.manage',
              ],
            },
            {
              uniqueId: 'report-sources',
              name: 'Wijzen van melden',
              routeOrFunction: '/instellingen/invoer/wijzen-van-melden',
              position: 20,
              permissions: [
                'configuration.report-sources.manage',
              ],
            },
            {
              uniqueId: 'report-priorities',
              name: 'Prioriteiten',
              routeOrFunction: '/instellingen/invoer/prioriteiten',
              position: 21,
              permissions: [
                'configuration.report-priorities.manage',
              ],
            },
            {
              uniqueId: 'report-history',
              name: 'Geschiedenis',
              routeOrFunction: '/instellingen/invoer/geschiedenis',
              position: 25,
              permissions: [
                'configuration.report-history.manage',
              ],
            },
          ]
        },
        {
          uniqueId: 'contractor-agreements',
          name: 'Verwerkersovereenkomst',
          routeOrFunction: '/instellingen/verwerkersovereenkomst',
          position: 32,
          permissions: [
            'configuration.contractor-agreement.manage',
          ],
        },
        {
          uniqueId: 'application-update-types',
          name: 'Update applicaties types',
          routeOrFunction: '/instellingen/handleiding/update-applicatie/types',
          position: 40,
          permissions: [
            'configuration.changelogs.types.manage',
          ],
        },
        {
          uniqueId: 'holidays',
          name: 'Feestdagen',
          routeOrFunction: '/instellingen/feestdagen',
          position: 60,
          permissions: [
            'configuration.holidays.manage',
          ]
        },
        {
          uniqueId: 'blocklist',
          name: 'Blokkadelijst',
          routeOrFunction: '/instellingen/blokkadelijst',
          position: 70,
          permissions: [
            'configuration.blacklist.manage',
          ],
        },
        {
          uniqueId: 'waste-orders-configuration',
          name: 'Afroeporders',
          alwaysOpened: false,
          position: 80,
          subItems: [
            {
              uniqueId: 'waste-order-statuses',
              name: 'Statussen',
              routeOrFunction: '/instellingen/afroeporders/statussen',
              position: 0,
              permissions: [
                'configuration.waste-order-statuses-and-types.manage'
              ],
            },
            {
              uniqueId: 'waste-order-types',
              name: 'Types',
              routeOrFunction: '/instellingen/afroeporders/types',
              position: 10,
              permissions: [
                'configuration.waste-order-statuses-and-types.manage',
              ],
            },
          ],
        },
        {
          uniqueId: 'postal-code-groups',
          name: 'Buurtindeling postcodes',
          routeOrFunction: '/instellingen/buurtindeling-postcodes',
          position: 90,
          permissions: [
            'configuration.postalcode-groups.manage',
          ],
        },
      ]
    },
    {
      uniqueId: 'reporters',
      name: 'Melders',
      icon: 'account_circle',
      position: 20,
      routeOrFunction: '/melders',
      alwaysOpened: false,
      permissions: [
        'reporters.manage',
      ],
    },
    {
      uniqueId: 'waste-calendar',
      name: 'Afvalkalender',
      icon: 'calendar_month',
      position: 160,
      alwaysOpened: false,
      permissions: [
        'waste-calendar.manage',
      ],
      subItems: [
        {
          uniqueId: 'waste-calendar-datasets',
          name: 'Datasets',
          routeOrFunction: '/afvalkalender/datasets',
          position: 0,
          permissions: [
            'waste-calendar.manage',
          ],
        },
        {
          uniqueId: 'waste-calendar-routes',
          name: 'Routes',
          routeOrFunction: '/afvalkalender/routes',
          position: 10,
          permissions: [
            'waste-calendar.manage'
          ],
        },
        {
          uniqueId: 'waste-calendar-locations',
          name: 'Locaties',
          routeOrFunction: '/afvalkalender/locaties',
          position: 20,
          permissions: [
            'waste-calendar.manage'
          ],
        },
        {
          uniqueId: 'waste-calendar-types',
          name: 'Soorten afval',
          routeOrFunction: '/afvalkalender/soorten-afval',
          position: 30,
          permissions: [
            'waste-calendar.manage'
          ],
        },
        {
          uniqueId: 'waste-calendar-test',
          name: 'Agenda testen',
          routeOrFunction: '/afvalkalender/test',
          position: 40,
          permissions: [
            'waste-calendar.manage'
          ],
        },
      ]
    },
    {
      uniqueId: 'archive',
      name: 'Archivering',
      routeOrFunction: '/archivering',
      icon: 'archive',
      position: 210,
      alwaysOpened: false,
      permissions: [
        'archive.manage',
      ],
    },
    {
      uniqueId: 'sent-emails',
      name: 'Sent Emails',
      routeOrFunction: '/sent-emails',
      icon: 'email',
      position: 220,
      alwaysOpened: false,
      permissions: [
        'sent-emails.logs'
      ],
    },
  ];
  private sidenavBottomItems: SidenavItem[] = [
    {
      uniqueId: 'help-and-support',
      name: 'Help & support',
      routeOrFunction: '/handleiding',
      icon: 'help',
      position: 10
    },
  ];

  constructor(private sidenavService: SidenavService,
              private iconRegistry: MatIconRegistry,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: Document,
              private platform: Platform,
              private splashScreenService: SplashScreenService, // required!! otherwise splashScreen does not go away on app load
              private authenticationService: AuthenticationService,
              private swUpdate: SwUpdate,
              private dialogService: MatDialog,
              private snackbarService: SnackbarService,
              private layoutService: LayoutService,
  ) {
    this.renderer.addClass(this.document.body, 'fury-default');
    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');
    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    if (this.swUpdate.isEnabled) {
      const oncePerHour$: Observable<number> = interval(360 * 1000);

      oncePerHour$.subscribe((): Promise<void> => this.swUpdate.checkForUpdate()
        .then((): void => console.log('checkForUpdate()'))
        .catch((error): void => {
          console.log('Service worker isn\'t supported or disabled!');
          throw new Error(error);
        }));

      this.swUpdate.versionUpdates.subscribe((event: VersionEvent): void => {
        if (!this.swUpdatePending) {
          if (event.type === 'VERSION_DETECTED') {
            this.snackbarService.info('Er is een nieuwe versie van de applicatie beschikbaar die op de achtergrond wordt klaargezet.');
          }
          if (event.type === 'VERSION_READY') {
            this.swUpdatePending = true;
            let dialogRef: MatDialogRef<AppUpdateDialogComponent>;
            dialogRef = this.dialogService.open(AppUpdateDialogComponent, {
              disableClose: true
            });
            dialogRef.afterClosed().subscribe(response => {
              if (response === true) {
                this.swUpdate.activateUpdate().then((): void => {
                  window.location.reload();
                });
              } else {
                this.layoutService.appUpdatePending = true;
                this.layoutService.updateApp.subscribe((): void => {
                  this.swUpdate.activateUpdate().then((): void => {
                    window.location.reload();
                  });
                });
              }
            });
          }
        }
      });
    }

    this.authenticationService.user$.subscribe((user: User): void => {
      if (!user) {
        if (!environment.production) {
          console.log('Sidenav: no user, clearing items');
        }
        this.sidenavService.items = [];
      }

      if (user) {
        if (!environment.production) {
          console.log('Sidenav: user propagated, adding or updating menu items');
        }
        this.sidenavService.addItems(this.sidenavTopItems);
        this.sidenavService.addItemsBottom(this.sidenavBottomItems);
      }
    });
  }
}
